import styled from 'styled-components';
import { Link } from 'react-router-dom';


export const PantallaInferencia = styled.div`

    width: 100%;
    height: 100%;

    min-height: 0;

    display: flex;
    flex-direction: column;

    font-family: 'Nunito';

    background-color: #FFFFFF;

    overflow: hidden;
`;


export const ContenidoInferencia = styled.div`

    width: 100%;

    flex: 1;

    min-height: 0;

    display: flex;

    justify-content: center;
    align-items: center;

    padding: 20px 4vw;

    box-sizing: border-box;

    overflow: hidden;
`;


export const SecuenciaInferencia = styled.div`

    width: 100%;
    max-width: 1250px;

    display: grid;

    grid-template-columns:
        repeat(
            3,
            minmax(0, 1fr)
        );

    justify-content: center;
    align-items: center;

    gap: clamp(
        16px,
        4vw,
        70px
    );


    @media (max-width: 800px) {

        gap: 12px;
    }
`;


export const PanelInferencia = styled.div`

    width: 100%;

    max-width: 360px;

    aspect-ratio: 1 / 1;

    justify-self: center;

    display: flex;

    justify-content: center;
    align-items: center;

    box-sizing: border-box;

    border: 1.5px solid #D9D9DE;

    border-radius: 16px;

    background-color: #FFFFFF;

    overflow: hidden;

    box-shadow:
        0 12px 26px -16px
        rgba(0, 0, 0, 0.22);

    opacity:
        ${props =>
            props.$visible
                ? 1
                : 0
        };

    transform:
        ${props =>
            props.$visible
                ? 'translateY(0)'
                : 'translateY(10px)'
        };

    transition:
        opacity 0.6s ease,
        transform 0.25s ease;


    img {

        width: 100%;
        height: 100%;

        display: block;

        object-fit: contain;
    }


    @media (max-height: 700px) {

        max-width: 290px;
    }


    @media (max-height: 600px) {

        max-width: 245px;
    }
`;


export const BottomInferencia = styled.div`

    width: 92%;

    min-height: 65px;

    margin: 0 auto;

    box-sizing: border-box;

    display: flex;

    justify-content: space-between;
    align-items: center;

    flex-shrink: 0;

    background-color: #FFFFFF;
`;


export const NavegacionInferencia = styled.div`

    display: flex;

    justify-content: center;
    align-items: center;

    gap: 14px;
`;


export const BotonFlechaInferencia = styled.button`

    width: 52px;
    height: 38px;

    padding: 0;

    border: none;

    border-radius: 11px;

    display: flex;

    justify-content: center;
    align-items: center;

    background:
        linear-gradient(
            180deg,
            #8C8C92,
            #68686E
        );

    box-shadow:
        0 3px 0 rgba(0, 0, 0, 0.20),
        0 8px 14px -4px rgba(40, 40, 55, 0.28);

    cursor: pointer;


    span {

        display: block;

        margin-top: -4px;

        font-size: 38px;
        font-weight: 600;

        line-height: 1;

        color: #FFFFFF;
    }


    &:hover:not(:disabled) {

        filter:
            brightness(1.07);
    }


    &:active:not(:disabled) {

        transform:
            translateY(3px);
    }


    &:disabled {

        opacity: 0.35;

        cursor: default;
    }


    @media (max-width: 600px) {

        width: 46px;
        height: 34px;


        span {

            font-size: 32px;
        }
    }
`;

export const MenuInferencia = styled.div`

    width: 100%;

    display: flex;

    justify-content: center;
    align-items: center;

    padding:
        clamp(
            16px,
            3vh,
            32px
        )
        clamp(
            20px,
            4vw,
            60px
        );

    box-sizing: border-box;

    overflow: visible;


    @media (max-height: 700px) {

        padding:
            10px
            25px;
    }


    @media (max-height: 580px) {

        padding:
            6px
            20px;
    }
`;


export const BotonesInferencia = styled.div`

    width: 100%;

    max-width: 1050px;

    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(
                240px,
                1fr
            )
        );

    justify-content: center;

    align-items: start;

    gap:
        clamp(
            28px,
            4vh,
            55px
        )
        clamp(
            40px,
            8vw,
            100px
        );


    @media (max-height: 700px) {

        gap:
            18px
            55px;
    }


    @media (max-height: 580px) {

        gap:
            10px
            45px;
    }


    @media (max-width: 700px) {

        grid-template-columns:
            1fr;

        max-width:
            330px;

        gap:
            25px;
    }
`;

export const BotonMenuInferencia = styled(Link)`

    width: 100%;

    text-decoration: none;

    color: #111111;

    display: flex;

    flex-direction: column;

    justify-content: flex-start;
    align-items: center;

    gap: 12px;

    font-family: 'Nunito';

    font-size:
        clamp(
            1rem,
            1.5vw,
            1.25rem
        );

    font-weight: 800;

    line-height: 1.2;

    text-align: center;

    cursor: pointer;


    img {

        width:
            min(
                100%,
                300px
            );

        aspect-ratio:
            16 / 10;

        display: block;

        object-fit: contain;

        box-sizing: border-box;

        background-color:
            #FFFFFF;

        border:
            2px solid
            #FF9D2E;

        border-radius:
            12px;

        box-shadow:
            0 4px 6px
            rgba(
                0,
                0,
                0,
                0.22
            );

        transition:
            transform
            0.18s ease,
            box-shadow
            0.18s ease;
    }


    span {

        color:
            #111111;

        text-transform:
            uppercase;

        text-shadow:
            1px 1px 2px
            rgba(
                0,
                0,
                0,
                0.18
            );
    }


    &:hover img {

        transform:
            translateY(-3px);

        box-shadow:
            0 7px 11px
            rgba(
                0,
                0,
                0,
                0.24
            );
    }


    &:active img {

        transform:
            translateY(1px);
    }


    /* =====================================================
       PANTALLAS CON MENOS ALTURA
       ===================================================== */

    @media (max-height: 700px) {

        gap: 7px;

        font-size:
            0.95rem;


        img {

            width:
                min(
                    100%,
                    240px
                );
        }
    }


    @media (max-height: 580px) {

        gap: 5px;

        font-size:
            0.85rem;


        img {

            width:
                min(
                    100%,
                    205px
                );
        }
    }


    /* =====================================================
       CELULAR / PANTALLA ANGOSTA
       ===================================================== */

    @media (max-width: 700px) {

        img {

            width:
                min(
                    100%,
                    280px
                );
        }
    }
`;

export const BotonFinalizarInferencia = styled.button`

    width: 64px;
    height: 48px;

    padding: 0;

    border: none;

    background-color: transparent;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;


    img {

        width: 60px;
        height: 46px;

        object-fit: contain;

        cursor: pointer;

        border-radius: 6px;
    }


    &:disabled {

        opacity: 0.4;

        cursor: default;
    }


    &:disabled img {

        cursor: default;
    }


    @media (max-width: 768px) {

        width: 50px;
        height: 38px;


        img {

            width: 48px;
            height: 36px;
        }
    }
`;

export const ContenidoLEN39 = styled.div`

    width: 100%;

    flex: 1;

    min-height: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 1.2rem 4vw;

    box-sizing: border-box;

    overflow: hidden;
`;


export const TarjetaLEN39 = styled.div`

    width: min(
        818px,
        82vw
    );

    max-height: 100%;

    display: flex;
    flex-direction: column;

    gap: clamp(
        10px,
        1.5vw,
        18px
    );
`;


export const TextoLEN39 = styled.div`

    width: 100%;

    color: #1F1F24;

    font-family: 'Nunito';

    font-size: clamp(
        17px,
        2vw,
        26px
    );

    line-height: 1.3;

    box-sizing: border-box;
`;


export const ImagenLEN39 = styled.div`

    position: relative;

    width: 100%;

    aspect-ratio: 818 / 425;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #FFFFFF;

    overflow: hidden;


    img {

        width: 100%;
        height: 100%;

        display: block;

        object-fit: contain;
    }


    @media (max-height: 750px) {

        max-height: 330px;
    }


    @media (max-height: 650px) {

        max-height: 270px;
    }
`;


export const PreguntaLEN39 = styled.div`

    width: 100%;

    padding:
        clamp(
            12px,
            2vw,
            22px
        )
        clamp(
            16px,
            3vw,
            30px
        );

    box-sizing: border-box;

    border: 1.5px solid #4E9B6E;

    border-radius: clamp(
        16px,
        2vw,
        26px
    );

    background-color: #EDF6F0;

    color: #1F1F24;

    font-family: 'Nunito';

    font-size: clamp(
        19px,
        2.3vw,
        32px
    );

    line-height: 1.25;
`;

export const ContenidoLEN40 = styled.div`

    width: 100%;

    flex: 1;

    min-height: 0;

    display: flex;

    justify-content: center;
    align-items: center;

    padding:
        1.5rem
        clamp(
            20px,
            4vw,
            55px
        );

    box-sizing: border-box;

    overflow: hidden;
`;


export const MixtaLEN40 = styled.div`

    width: 100%;

    max-width: 1180px;

    display: grid;

    grid-template-columns:
        minmax(
            300px,
            0.95fr
        )
        minmax(
            340px,
            1.05fr
        );

    column-gap:
        clamp(
            35px,
            7vw,
            120px
        );

    align-items: center;


    @media (
        max-width: 800px
    ) {

        display: flex;

        flex-direction: column;

        gap: 20px;

        max-width: 560px;

        overflow-y: auto;
    }
`;


export const ImagenLEN40 = styled.div`

    width: 100%;

    max-width: 500px;

    aspect-ratio: 1 / 1;

    display: flex;

    justify-content: center;
    align-items: center;

    background-color:
        #FFFFFF;

    overflow: hidden;


    img {

        width: 100%;

        height: 100%;

        display: block;

        object-fit: contain;
    }


    @media (
        max-height: 720px
    ) {

        max-width: 390px;
    }


    @media (
        max-height: 620px
    ) {

        max-width: 320px;
    }


    @media (
        max-width: 800px
    ) {

        width:
            min(
                100%,
                360px
            );
    }
`;


export const DerechaLEN40 = styled.div`

    width: 100%;

    display: flex;

    flex-direction: column;

    min-width: 0;
`;


export const FraseLEN40 = styled.p`

    margin:
        0
        0
        0.7rem
        0;

    color:
        #1F1F24;

    font-family:
        'Nunito';

    font-size:
        clamp(
            17px,
            1.7vw,
            25px
        );

    font-weight:
        500;

    line-height:
        1.3;
`;


export const PreguntaTextoLEN40 = styled.p`

    margin:
        0
        0
        clamp(
            20px,
            3vw,
            42px
        )
        0;

    color:
        #1F1F24;

    font-family:
        'Nunito';

    font-size:
        clamp(
            20px,
            2.1vw,
            31px
        );

    font-weight:
        700;

    line-height:
        1.25;
`;


export const RespuestasLEN40 = styled.div`

    width: 100%;

    display: flex;

    flex-direction: column;

    gap:
        clamp(
            10px,
            1.1vw,
            16px
        );
`;


export const RespuestaLEN40 = styled.button`

    width: 100%;

    appearance: none;

    text-align: left;

    padding:
        clamp(
            12px,
            1.4vw,
            20px
        )
        clamp(
            18px,
            2.4vw,
            35px
        );

    box-sizing:
        border-box;

    border:
        1.5px solid
        ${props => {

            if (
                props.$correcta
            ) {

                return '#4E9B6E';
            }


            if (
                props.$incorrecta
            ) {

                return '#C85A5A';
            }


            if (
                props.$seleccionada
            ) {

                return '#4E9B6E';
            }


            return '#D9D9DE';
        }};

    border-radius:
        clamp(
            14px,
            1.5vw,
            22px
        );

    background-color:
        ${props => {

            if (
                props.$correcta
            ) {

                return '#EDF6F0';
            }


            if (
                props.$incorrecta
            ) {

                return '#FCEEEE';
            }


            if (
                props.$seleccionada
            ) {

                return '#EDF6F0';
            }


            return '#FFFFFF';
        }};

    color:
        #1F1F24;

    font-family:
        'Nunito';

    font-size:
        clamp(
            17px,
            1.8vw,
            27px
        );

    font-weight:
        500;

    line-height:
        1.2;

    cursor:
        pointer;

    transition:
        transform 0.2s ease,
        border-color 0.2s ease,
        background-color 0.2s ease,
        box-shadow 0.2s ease;


    &:hover:not(:disabled) {

        transform:
            translateY(-3px);

        border-color:
            #B9B9C0;

        box-shadow:
            0
            12px
            20px
            -14px
            rgba(
                0,
                0,
                0,
                0.28
            );
    }


    &:disabled {

        cursor:
            default;
    }
`;

export const ContenidoLEN41 = styled.div`

    width: 100%;
    flex: 1;
    min-height: 0;

    display: flex;

    justify-content: center;
    align-items: center;

    padding:
        1.5rem
        clamp(
            20px,
            4vw,
            55px
        );

    box-sizing: border-box;

    overflow: hidden;
`;


export const LecturaLEN41 = styled.div`

    width: 100%;

    max-width: 1180px;

    display: grid;

    grid-template-columns:
        minmax(
            320px,
            1fr
        )
        minmax(
            320px,
            0.98fr
        );

    column-gap:
        clamp(
            30px,
            5vw,
            65px
        );

    align-items: center;


    @media (
        max-width: 760px
    ) {

        display: flex;

        flex-direction: column;

        gap: 20px;

        max-width: 560px;

        overflow-y: auto;
    }
`;


export const TarjetaTextoLEN41 = styled.div`

    width: 100%;

    border:
        1.5px solid
        #86D0D3;

    border-radius:
        clamp(
            14px,
            2.2vw,
            26px
        );

    background:
        #E9F6F7;
`;


export const TextoLEN41 = styled.div`

    padding:
        clamp(
            20px,
            4vw,
            44px
        )
        clamp(
            20px,
            3.5vw,
            40px
        );

    color:
        #1F1F24;

    font-family:
        'Nunito';

    font-size:
        clamp(
            17px,
            2vw,
            30px
        );

    font-weight:
        400;

    line-height:
        1.6;
`;


export const FraseMarcableLEN41 = styled.button`

    appearance: none;

    border: none;

    background:
        ${props =>
            props.$marcada
                ? '#CAEBEC'
                : 'transparent'
        };

    color:
        inherit;

    font:
        inherit;

    line-height:
        inherit;

    padding:
        2px 4px;

    margin:
        -2px -4px;

    border-radius:
        8px;

    cursor:
        pointer;

    text-align:
        left;

    transition:
        background-color
        0.2s ease;


    &:hover {

        background:
            #DCF1F2;
    }
`;


export const DerechaLEN41 = styled.div`

    width: 100%;

    min-width: 0;

    display: flex;

    flex-direction: column;
`;


export const PreguntaLEN41 = styled.p`

    margin:
        0
        0
        clamp(
            26px,
            4vw,
            64px
        )
        0;

    color:
        #1F1F24;

    font-family:
        'Nunito';

    font-size:
        clamp(
            18px,
            2.15vw,
            31px
        );

    font-weight:
        500;

    line-height:
        1.25;


    @media (
        max-width: 760px
    ) {

        margin-bottom:
            12px;
    }
`;


export const RespuestasLEN41 = styled.div`

    width: 100%;

    display: flex;

    flex-direction: column;

    gap:
        clamp(
            10px,
            1.1vw,
            16px
        );
`;


export const RespuestaColorLEN41 = styled.button`

    width: 100%;

    appearance: none;

    display: flex;

    align-items: center;

    gap:
        clamp(
            12px,
            1.4vw,
            20px
        );

    text-align: left;

    padding:
        clamp(
            12px,
            1.5vw,
            22px
        )
        clamp(
            16px,
            2.4vw,
            34px
        );

    border:
        1.5px solid
        ${props =>
            props.$seleccionada
                ? '#777777'
                : '#D6D6D6'
        };

    border-radius:
        clamp(
            14px,
            1.7vw,
            24px
        );

    background:
        ${props =>
            props.$seleccionada
                ? '#EEEEEE'
                : '#FFFFFF'
        };

    color:
        #1F1F24;

    font-family:
        'Nunito';

    font-size:
        clamp(
            17px,
            2vw,
            30px
        );

    font-weight:
        400;

    line-height:
        1.2;

    cursor:
        pointer;

    transition:
        transform 0.2s ease,
        border-color 0.2s ease,
        background-color 0.2s ease,
        box-shadow 0.2s ease;


    > span {

        flex: none;

        width:
            clamp(
                18px,
                1.7vw,
                24px
            );

        aspect-ratio:
            1;

        border-radius:
            50%;

        border:
            2px solid
            ${props =>
                props.$seleccionada
                    ? '#666666'
                    : '#A7A7A7'
            };

        background:
            ${props =>
                props.$seleccionada
                    ? 'radial-gradient(circle, #666666 0 42%, #FFFFFF 46%)'
                    : '#FFFFFF'
            };
    }


    &:hover:not(:disabled) {

        transform:
            translateY(-2px);

        border-color:
            #999999;

        box-shadow:
            0 8px 18px -14px
            rgba(
                0,
                0,
                0,
                0.45
            );
    }


    &:disabled {

        cursor:
            default;
    }
`;